import * as bytescale from "@bytescale/sdk";

export function isBytescaleFile(
  filePath: string | null | undefined,
): filePath is string {
  return (
    !!filePath && !/^https?:\/\//.test(filePath) && !/^blob:/.test(filePath)
  );
}

export function processFilePath<T extends string | null | undefined>(
  filePath: T,
  accountId: string,
  options: bytescale.UrlBuilderOptions | undefined = {},
) {
  if (!isBytescaleFile(filePath)) {
    return filePath;
  }

  return bytescale.UrlBuilder.url({
    accountId,
    filePath: filePath,
    options: options,
  });
}

export function processAudioFilePath<T extends string | null | undefined>(
  filePath: T,
  accountId: string,
  options:
    | Omit<bytescale.UrlBuilderOptionsAudio, "transformation">
    | undefined = {},
) {
  return processFilePath(filePath, accountId, {
    ...options,
    transformation: "audio",
  });
}

export function processImageFilePath<T extends string | null | undefined>(
  filePath: T,
  accountId: string,
  options:
    | Omit<bytescale.UrlBuilderOptionsImage, "transformation">
    | undefined = {},
) {
  return processFilePath(filePath, accountId, {
    ...options,
    transformation: "image",
    transformationParams: {
      f: "webp",
      c: 100,
      q: 70,
      ...options.transformationParams,
    },
  });
}

export function processVideoFilePath<T extends string | null>(
  filePath: T,
  accountId: string,
  options:
    | Omit<bytescale.UrlBuilderOptionsVideo, "transformation">
    | undefined = {},
) {
  return processFilePath(filePath, accountId, {
    transformationParams: {
      f: "mp4-h264",
    },
    transformation: "video",
    ...options,
  });
}
